import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_OrderController_CreateOne_Input_OwnerType,
  useOrderCreateMutation,
} from 'api/generated/graphql';
import {
  parseCreateOrderParams,
  parseOrderEntity,
  useError,
} from 'api/helpers';
import { CreateOrderParams } from 'api/types/params';

export const useCreateOrder = () => {
  const [createOrder, { loading, error: apolloError }] =
    useOrderCreateMutation();

  const error = useError(apolloError);

  return {
    createOrder: useCallback(
      async (
        ownerId: string,
        ownerType: 'Client' | 'LegalClient',
        token: string,
        params: CreateOrderParams
      ) => {
        const input = parseCreateOrderParams(params);
        const res = await createOrder({
          variables: {
            input: {
              ownerId,
              ownerType:
                MutationInput_OrderController_CreateOne_Input_OwnerType[
                  ownerType
                ],
              token,
              ...input,
            },
          },
        });
        return res.data?.orderCreate
          ? parseOrderEntity(res.data?.orderCreate)
          : null;
      },
      [createOrder]
    ),
    loading,
    error,
  };
};
